import { CloseIcon, GoIcon } from "@/components/icons";
import { Flex, Image, Text } from "@chakra-ui/react";
import { useUserInfo } from "@/context/UserInfo";
import { useNavigate } from "react-router-dom";

import WarnIcon from "./assets/warn.png";
import ApprovedIcon from "./assets/approved.png";

const KycStatus = () => {
  const { bridgeCustomer } = useUserInfo();
  const navigate = useNavigate();
  return (
    <>
      {bridgeCustomer?.status === "active" ? (
        <Flex
          sx={{
            width: "90px",
            height: "16px",
            flexShrink: 0,
            borderRadius: "100px",
            background: "#FFF",
            boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.10)",
          }}
          align={"center"}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            console.log(bridgeCustomer, "bridgeCustomer");
            navigate("/verifyInfo");
          }}
        >
          <Image
            src={ApprovedIcon}
            sx={{ width: "10px", margin: "0 6px 0 4px" }}
          ></Image>
          <Text
            sx={{
              color: "#00B327",
              fontSize: "12px",
              fontWeight: 500,
            }}
          >
            Verified
          </Text>
        </Flex>
      ) : (
        <Flex
          sx={{
            width: "90px",
            height: "16px",
            flexShrink: 0,
            borderRadius: "100px",
            background: "#FFBBB2",
          }}
          align={"center"}
          justify={"space-around"}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            console.log(bridgeCustomer, "bridgeCustomer");
            if (bridgeCustomer.id) {
              navigate("/verifyInfo");
            } else {
              navigate("/createKyc");
            }
          }}
        >
          <Image src={WarnIcon} sx={{ width: "10px" }}></Image>
          <Text
            sx={{
              color: "#C22B2B",
              fontSize: "12px",
              fontWeight: 500,
            }}
          >
            Unverified
          </Text>
          <GoIcon style={{ width: "10px", color: "#C22B2B" }}></GoIcon>
        </Flex>
      )}
    </>
  );
};

export default KycStatus;
